const margins = {
  default: 15,
  contentLogin: 30,
  inputBottom: 10,
  inputTop: 15,
  titleBottom: 30,
  labelBottom: 5,
  labelTop: 5,
  links: 20,
  title: 15,
  reset: 0,
  divider: 10,
  alternative: 10,
};

export default margins;
